import Sitemap from './Sitemap.component';

export default Sitemap;
